export const FD_TICKET = "FD_TICKET";
export const CREATE_FD_RESULT = "CREATE_FD_RESULT";
export const GET_VIEW_FD = "GET_VIEW_FD";
